export default "__VITE_ASSET__CUZqVFv3__"